
export const actions = {
    GET_CHECKIN_ADVERT: 'contactForm/getCheckinAdvert',
    GET_VERIFY_ADVERT: 'contactForm/getVerifyAdvert'
}
